var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { staticClass: "fullSize" },
    [
      _vm.loading || !_vm.settingsLoaded
        ? _c("loading-page")
        : _vm.pageIsEmpty
        ? _c("default-page", {
            attrs: {
              imageUrl: "/img/dynamic-src-images/price-guard.svg",
              title: _vm.$options.name,
              text: _vm.emptyPageText,
              buttonText: "Get Started",
            },
            on: {
              "button-clicked": function ($event) {
                return _vm.$router.push({
                  path: _vm.PGInstancesLength ? "/eventrules" : "/applications",
                  query: {
                    add: true,
                  },
                })
              },
            },
          })
        : _c(
            "div",
            { staticClass: "elevation-1 fullSize fillHeight" },
            [
              _c("confirm-dialog", {
                attrs: {
                  dialog: _vm.confirmDialog,
                  text: _vm.itemDeletionText,
                  acceptButton: "Delete",
                },
                on: {
                  "confirmation-event": function ($event) {
                    return _vm.deleteItem($event)
                  },
                  "mutate-confirm-dialog": _vm.mutateConfirmDialog,
                },
              }),
              _c(
                "v-row",
                { staticClass: "mx-0", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: "toolbar",
                          attrs: { height: "35", flat: "", color: "#2d3436" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mx-0",
                              staticStyle: {
                                "max-height": "36px",
                                "min-height": "36px",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0 mt-0",
                                  attrs: { cols: "12", md: "12", sm: "12" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    { staticClass: "mx-0" },
                                    [
                                      _c(
                                        "v-list",
                                        {
                                          staticClass: "pY-0 sorting-menu",
                                          attrs: { "max-height": "36px" },
                                        },
                                        [
                                          _c(
                                            "v-list-item",
                                            {
                                              staticClass: "pl-1 pr-1 pl-3",
                                              attrs: {
                                                id: "sortby-list",
                                                dense: "",
                                                "max-height": "36px",
                                              },
                                              on: { click: () => {} },
                                            },
                                            [
                                              _c(
                                                "v-list-item-content",
                                                {
                                                  attrs: {
                                                    "max-height": "36px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass: "listText",
                                                      attrs: {
                                                        "max-height": "36px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass: "mb-0",
                                                          class: {
                                                            "mr-2":
                                                              _vm.$vuetify
                                                                .breakpoint
                                                                .smAndDown,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$vuetify
                                                                  .breakpoint
                                                                  .xsOnly
                                                                  ? "Sort "
                                                                  : "Sort By -"
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.if_smAndDown_else(
                                                                  _vm.selectedSort.slice(
                                                                    0,
                                                                    3
                                                                  ),
                                                                  _vm.selectedSort
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.$vuetify.breakpoint.mdAndUp
                                                ? _c(
                                                    "v-list-item-action",
                                                    {
                                                      attrs: {
                                                        "max-height": "36px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          style: _vm.$vuetify
                                                            .theme.dark
                                                            ? "color: #47BD96"
                                                            : "color: white",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.openSortingList
                                                                  ? "keyboard_arrow_up"
                                                                  : "keyboard_arrow_down"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            activator: "#sortby-list",
                                            "open-on-click": "",
                                            "content-class": "sortby-list",
                                            "offset-y": "",
                                          },
                                          model: {
                                            value: _vm.openSortingList,
                                            callback: function ($$v) {
                                              _vm.openSortingList = $$v
                                            },
                                            expression: "openSortingList",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list",
                                            { staticClass: "py-0" },
                                            _vm._l(
                                              _vm.sortingAlgorithms,
                                              function (algorithm, i) {
                                                return _c(
                                                  "v-list-item",
                                                  {
                                                    key: i,
                                                    staticClass:
                                                      "px-0 sorting-options",
                                                    attrs: {
                                                      disabled: i === 2,
                                                      "aria-disabled": true,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.sortByStatus(
                                                          algorithm.name
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass: "listText",
                                                        class: {
                                                          disabled: i === 2,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            algorithm.name
                                                          ) + " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.ignoredItems.length > 0
                                        ? _c(
                                            "v-list",
                                            {
                                              staticClass: "py-0 ignored-menu",
                                              attrs: {
                                                width: _vm.if_smAndDown_else(
                                                  _vm.$vuetify.breakpoint.xsOnly
                                                    ? 100
                                                    : 150,
                                                  184
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "v-list-item",
                                                {
                                                  staticClass:
                                                    "ignored-menu-v-list-item pl-3",
                                                  attrs: {
                                                    id: "ignoreditems-list",
                                                    dense: "",
                                                  },
                                                  on: { click: () => {} },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _vm.$vuetify.breakpoint
                                                        .xsOnly
                                                        ? _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "listText",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Ignored Items "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "listText",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Ignored Items : " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .ignoredItems
                                                                      .length
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm.$vuetify.breakpoint
                                                    .mdAndUp
                                                    ? _c(
                                                        "v-list-item-action",
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              style: _vm
                                                                .$vuetify.theme
                                                                .dark
                                                                ? "color: #47BD96"
                                                                : "color: white",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.openIgnoreList
                                                                      ? "keyboard_arrow_up"
                                                                      : "keyboard_arrow_down"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.ignoredItems.length > 0
                                        ? _c(
                                            "v-menu",
                                            {
                                              attrs: {
                                                activator: "#ignoreditems-list",
                                                "open-on-click": "",
                                                "close-on-content-click": false,
                                                "offset-y": "",
                                              },
                                              model: {
                                                value: _vm.openIgnoreList,
                                                callback: function ($$v) {
                                                  _vm.openIgnoreList = $$v
                                                },
                                                expression: "openIgnoreList",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-list",
                                                {
                                                  staticClass:
                                                    "py-0 overflow-y-auto",
                                                  style: ` max-width: ${_vm.if_smAndDown_else(
                                                    _vm.$vuetify.breakpoint
                                                      .xsOnly
                                                      ? "100"
                                                      : "150",
                                                    "200"
                                                  )}px !important;`,
                                                  attrs: {
                                                    "max-height": "400",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.ignoredItems,
                                                  function (item, i) {
                                                    return _c(
                                                      "v-list-item",
                                                      {
                                                        key: i,
                                                        staticClass:
                                                          "ignoredItems",
                                                        staticStyle: {
                                                          "padding-right":
                                                            "4px",
                                                          "padding-left": "4px",
                                                          overflow: "hidden",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-content",
                                                          {
                                                            staticClass:
                                                              "pt-1 pb-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              {
                                                                staticClass:
                                                                  "listText",
                                                              },
                                                              [
                                                                !_vm.if_smAndDown_else()
                                                                  ? _c(
                                                                      "div",
                                                                      [
                                                                        _c(
                                                                          "v-row",
                                                                          {
                                                                            staticClass:
                                                                              "mx-1",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-1 mr-3",
                                                                                staticStyle:
                                                                                  {
                                                                                    "font-size":
                                                                                      "14px !important",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Name: "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-1",
                                                                                staticStyle:
                                                                                  {
                                                                                    "font-size":
                                                                                      "14px !important",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "  " +
                                                                                    _vm._s(
                                                                                      item.name
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _c(
                                                                      "v-row",
                                                                      {
                                                                        staticClass:
                                                                          "pb-1",
                                                                        attrs: {
                                                                          "no-gutters":
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "8",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.name
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                !_vm.if_smAndDown_else()
                                                                  ? _c(
                                                                      "div",
                                                                      [
                                                                        _c(
                                                                          "v-row",
                                                                          {
                                                                            staticClass:
                                                                              "mx-1",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-1 mr-1",
                                                                                staticStyle:
                                                                                  {
                                                                                    "font-size":
                                                                                      "14px !important",
                                                                                    "margin-bottom":
                                                                                      "-2px",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Symbol: "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-1",
                                                                                staticStyle:
                                                                                  {
                                                                                    "font-size":
                                                                                      "14px !important",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      item.symbol
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _c(
                                                                      "v-row",
                                                                      {
                                                                        attrs: {
                                                                          "no-gutters":
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "8",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.symbol
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            class: _vm.$vuetify
                                                              .theme.dark
                                                              ? _vm.if_smAndDown_else(
                                                                  "removeFromIgnored_mobile removeFromIgnored_dark",
                                                                  "removeFromIgnored removeFromIgnored_dark"
                                                                )
                                                              : _vm.if_smAndDown_else(
                                                                  "removeFromIgnored_mobile removeFromIgnored_light",
                                                                  "removeFromIgnored removeFromIgnored_light"
                                                                ),
                                                            attrs: {
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.unignoreItemInList(
                                                                  item,
                                                                  i
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("close ")]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.$vuetify.breakpoint.smAndUp
                                        ? _c("v-text-field", {
                                            staticClass: "pg-search ml-2 mt-1",
                                            style: `${
                                              _vm.$vuetify.breakpoint.smAndDown
                                                ? "margin-left: 100px;max-width:120px;"
                                                : "margin-right: 10px;max-width:250px;"
                                            }`,
                                            attrs: {
                                              id: "quick-search",
                                              dark: "",
                                              color: _vm.$vuetify.theme.dark
                                                ? "primary"
                                                : "secondary",
                                              value: _vm.search,
                                              "append-icon": "search",
                                              label: "Search",
                                              "single-line": "",
                                              "hide-details": "",
                                              dense: "",
                                            },
                                            on: {
                                              input: _vm.onFilterTextBoxChanged,
                                            },
                                          })
                                        : _vm._e(),
                                      _c("v-checkbox", {
                                        staticClass: "mt-1 ml-2",
                                        attrs: {
                                          dark: "",
                                          color: _vm.$vuetify.theme.dark
                                            ? "primary"
                                            : "white",
                                          dense: "",
                                          height: "30",
                                          "align-self": "center",
                                          "off-icon": "far fa-square",
                                          "on-icon": "fas fa-check-square",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.dataExpiring,
                                          callback: function ($$v) {
                                            _vm.dataExpiring = $$v
                                          },
                                          expression: "dataExpiring",
                                        },
                                      }),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-0 mt-2 white--text",
                                          attrs: { id: "expiringof-price" },
                                        },
                                        [_vm._v(" Expiring ")]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            activator: "#expiringof-price",
                                            bottom: "",
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Remove expired data every " +
                                                _vm._s(
                                                  _vm.removeExpiredDataAfter
                                                ) +
                                                " second(s)"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.$vuetify.breakpoint.mdAndUp,
                                              expression:
                                                "$vuetify.breakpoint.mdAndUp",
                                            },
                                          ],
                                          attrs: { id: "pg-status-info" },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mt-2 mb-0 ml-8 d-inline-block status status-info white--text",
                                              staticStyle: {
                                                "font-size": "14px",
                                              },
                                            },
                                            [_vm._v(" Price Status ")]
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass:
                                                "d-inline-block pl-2",
                                              staticStyle: {
                                                "margin-bottom": "2px",
                                                "font-size": "14px",
                                              },
                                              attrs: {
                                                small: "",
                                                color: "primary",
                                              },
                                            },
                                            [_vm._v(" far fa-question-circle ")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            color: "rgba(19,19,21,1)",
                                            activator: "#pg-status-info",
                                            "nudge-top": "12",
                                            "nudge-right": "14",
                                            bottom: "",
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "status new mb-0",
                                                staticStyle: {
                                                  "margin-left": "-8px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " New (Matched less than a minute ago) "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticClass: "status old mb-0",
                                                staticStyle: {
                                                  "margin-left": "-8px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " Old (Matched more than a minute ago) "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "status expired mb-0",
                                                staticStyle: {
                                                  "margin-left": "-8px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " Expired (Not valid anymore) "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "status important mb-0",
                                                staticStyle: {
                                                  "margin-left": "-8px",
                                                },
                                              },
                                              [_vm._v(" Important ")]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "status ignore mb-2",
                                                staticStyle: {
                                                  "margin-left": "-8px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " Ignored (Is ignored, no notification) "
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c("v-spacer"),
                                      _vm.$vuetify.breakpoint.smAndUp
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "mt-1 mx-2",
                                              attrs: {
                                                text: "",
                                                icon: "",
                                                small: "",
                                                "aria-label": "volume",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$emit(
                                                    "mute-priceguard"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm.priceGuardMute
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { color: "grey" },
                                                    },
                                                    [_vm._v("volume_off ")]
                                                  )
                                                : _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { color: "white" },
                                                    },
                                                    [_vm._v("volume_up")]
                                                  ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.$vuetify.breakpoint.smAndUp
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "btn-clear mr-12",
                                              class:
                                                _vm.$vuetify.breakpoint.width <
                                                350
                                                  ? "clearButtonClass"
                                                  : "useLessClass",
                                              attrs: {
                                                elevation: "0",
                                                id:
                                                  _vm.$vuetify.breakpoint
                                                    .width < 350
                                                    ? "clearButton"
                                                    : "userlessId",
                                                "x-small":
                                                  _vm.$vuetify.breakpoint
                                                    .width < 350,
                                                small:
                                                  _vm.$vuetify.breakpoint
                                                    .width >= 350,
                                                width: _vm.$vuetify.breakpoint
                                                  .xsOnly
                                                  ? "45px"
                                                  : "85px",
                                                color: _vm.$vuetify.theme.dark
                                                  ? "primary"
                                                  : "primary",
                                              },
                                              on: {
                                                click: _vm.clearAllMarketData,
                                              },
                                            },
                                            [_vm._v("Clear ")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.$vuetify.breakpoint.xsOnly
                                    ? _c(
                                        "v-menu",
                                        {
                                          staticClass: "borderRad-sm",
                                          staticStyle: {
                                            display: "initial !important",
                                          },
                                          attrs: {
                                            "close-on-content-click": false,
                                            bottom: "",
                                            left: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "white--text more-btn",
                                                          attrs: {
                                                            icon: "",
                                                            text: "",
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "icon-more-21x21",
                                                            staticStyle: {
                                                              "font-size":
                                                                "28px",
                                                              "margin-right":
                                                                "2px",
                                                              "letter-spacing":
                                                                "0em !important",
                                                            },
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "path1 letterSpacing0",
                                                            }),
                                                            _c("span", {
                                                              staticClass:
                                                                "path2 letterSpacing0",
                                                            }),
                                                            _c("span", {
                                                              staticClass:
                                                                "path3 letterSpacing0",
                                                            }),
                                                            _c("span", {
                                                              staticClass:
                                                                "path4 letterSpacing0",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            1691288674
                                          ),
                                          model: {
                                            value: _vm.more_menu,
                                            callback: function ($$v) {
                                              _vm.more_menu = $$v
                                            },
                                            expression: "more_menu",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list",
                                            { staticClass: "text-center" },
                                            [
                                              _c(
                                                "v-list-item",
                                                { staticClass: "text-center" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "pg-search ml-2 mt-1",
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                      "max-width": "250px",
                                                    },
                                                    attrs: {
                                                      id: "quick-search",
                                                      dark: "",
                                                      color: _vm.$vuetify.theme
                                                        .dark
                                                        ? "primary"
                                                        : "secondary",
                                                      value: _vm.search,
                                                      "append-icon": "search",
                                                      label: "Search",
                                                      "single-line": "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input:
                                                        _vm.onFilterTextBoxChanged,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "text-center mx-auto px-2 mt-3",
                                                      class:
                                                        _vm.$vuetify.breakpoint
                                                          .width < 350
                                                          ? "clearButtonClass"
                                                          : "useLessClass",
                                                      attrs: {
                                                        elevation: "0",
                                                        id:
                                                          _vm.$vuetify
                                                            .breakpoint.width <
                                                          350
                                                            ? "clearButton"
                                                            : "userlessId",
                                                        "x-small":
                                                          _vm.$vuetify
                                                            .breakpoint.width <
                                                          350,
                                                        width: "70px",
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.clearAllMarketData()
                                                          _vm.more_menu = false
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Clear ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "mt-1 mx-2 text-center mx-auto",
                                                      attrs: {
                                                        text: "",
                                                        icon: "",
                                                        small: "",
                                                        "aria-label": "volume",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "mute-priceguard"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm.priceGuardMute
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color: "grey",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "volume_off "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color: _vm
                                                                  .$vuetify
                                                                  .theme.dark
                                                                  ? "white"
                                                                  : "grey",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "volume_up"
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm.$vuetify.breakpoint.mdAndUp
                                ? _c("v-col", {
                                    attrs: {
                                      cols:
                                        _vm.$vuetify.breakpoint.width > 1630
                                          ? "1"
                                          : _vm.$vuetify.breakpoint.smAndDown
                                          ? "2"
                                          : "2",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "fullSize", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    [
                      _c("ag-grid-vue", {
                        staticClass: "ag-grid--pg",
                        class: _vm.$vuetify.theme.dark
                          ? "ag-theme-custom-balham-dark-vue"
                          : "ag-theme-custom-balham-vue",
                        staticStyle: { height: "100%", width: "100%" },
                        attrs: {
                          gridOptions: _vm.gridOptions,
                          columnDefs: _vm.columnDefs,
                          defaultColDef: _vm.defaultColDef,
                          masterDetail: true,
                          isRowMaster: _vm.isRowMaster,
                          frameworkComponents: _vm.frameworkComponents,
                          context: _vm.context,
                          postSort: _vm.postSort,
                          rowClassRules: _vm.rowClassRules,
                          detailCellRendererParams:
                            _vm.detailCellRendererParams,
                          detailRowHeight: 90,
                          modules: _vm.modules,
                          rowData: _vm.getPriceGuardEvents,
                          immutableData: true,
                          getRowNodeId: _vm.getRowNodeId,
                        },
                        on: { "grid-ready": _vm.onGridReady },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }